<template>
    <div class="container">
        <vue-headful
                title="Events - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">All Event</h3>
                            </div>
                            <div class="">
                                <router-link class="btn btn-primary" :to="{name: 'website-create-event'}">ADD EVENT</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">Event Title</th>
                                <!--<th scope="col">Event Url</th>-->
                                <th scope="col">Event Start Date</th>
                                <th scope="col">Event End Date</th>
                                <!--<th scope="col">Event Description</th>-->
                                <!--<th scope="col">Event Works</th>-->
                                <!--<th scope="col">Event Agenda</th>-->
                                <!--<th scope="col">Event Venue</th>-->
                                <th scope="col">Event Fee</th>
                                <th scope="col">Event City</th>
                                <th scope="col">Event Location</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="event in eventAdd" :key="event.id">
                                <td>
                                    <button @click="deleteEvent(event.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Event"></button>
                                    <button @click="editEvent(event.id)" type="button" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Event"></button>
                                </td>
                                <td scope="row">
                                    <strong>{{event.event_title}}</strong>
                                </td>
                                <!--<td></td>-->
                                <td>
                                    {{event.event_date}}
                                </td>
                                <td>
                                    {{event.event_date_registration_end}}
                                </td>
                                <!--<td>-->
                                    <!--{{event.event_description}}-->
                                <!--</td>-->
                                <!--<td>-->
                                    <!--{{event.event_how_it_works}}-->
                                <!--</td>-->
                                <!--<td>-->
                                    <!--{{event.event_agenda}}-->
                                <!--</td>-->
                                <!--<td>-->
                                    <!--{{event.event_venue}}-->
                                <!--</td>-->
                                <td>
                                    {{event.event_fee}}
                                </td>
                                <td>
                                    {{event.event_city}}
                                </td>
                                <td>
                                    {{event.event_location}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      eventAdd: {}
    };
  },
  methods: {
    goNew: function() {
      window.location.href = "/dashboard/website/create-event";
    },
    editEvent: function(event_id) {
      window.location.href = "/dashboard/website/update-event/" + event_id;
    },
    get_Events() {
      axios({
        url:
          "admin/events?access_token=" + localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.eventAdd = result.data.events.data;
            console.log(result);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteEvent(id) {
      axios({
        method: "delete",
        url: "admin/events/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Event Deleted Successfully", "", "success");
            console.log(result);
            this.get_Events();
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_Events();
  }
};
</script>
<style>
</style>
